export default {
	api: 'http://localhost:4800',
	loginTimeout: 86400
};
